import React from 'react';
import Loading from 'researcher/components/Loading';
var LocalAuthEnabled = function LocalAuthEnabled(_ref) {
  var children = _ref.children,
    className = _ref.className,
    providers = _ref.providers,
    redirect = _ref.redirect,
    referringUrl = _ref.referringUrl;
  if (redirect) {
    var referringUrlRedirect = referringUrl ? "?redirect=".concat(referringUrl) : '';
    // If we don't have local auth enabled, redirect to the first configured provider
    window.location.replace("/api/auth/opa/".concat(providers[0].id).concat(referringUrlRedirect));
  }
  return !redirect ? /*#__PURE__*/React.createElement("div", {
    className: className
  }, children) : /*#__PURE__*/React.createElement(Loading, null);
};
export default LocalAuthEnabled;